import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import ProtectionPlans from '../home/components/ProtectionPlans';

const plans = [
  {
    name: 'Basic',
    price: 199,
    period: 'year',
    description: 'Essential HVAC maintenance for reliable comfort',
    badge: '',
    color: '#E8A317',
    features: [
      '2 Annual Tune-Ups (Spring & Fall)',
      'Priority Scheduling',
      '10% Discount on Repairs',
      'Thermostat Calibration',
      'Basic System Inspection',
      'Coil Cleaning Service',
    ],
  },
  {
    name: 'Premium',
    price: 349,
    period: 'year',
    description: 'Comprehensive protection with priority service',
    badge: 'MOST POPULAR',
    color: '#C41E3A',
    features: [
      '4 Annual Tune-Ups (Quarterly)',
      'Priority Emergency Service',
      '15% Discount on Repairs',
      'Thermostat Calibration',
      'Ductwork Inspection',
      'Refrigerant Level Check',
      'Coil Cleaning Service',
      'Extended Parts Warranty',
    ],
  },
  {
    name: 'Elite',
    price: 599,
    period: 'year',
    description: 'Ultimate peace of mind with full coverage',
    badge: 'BEST VALUE',
    color: '#1B3A6B',
    features: [
      '6 Annual Tune-Ups (Bi-Monthly)',
      '24/7 Emergency Service',
      '20% Discount on Repairs',
      'Thermostat Calibration & Upgrade Consultation',
      'Full Ductwork Inspection & Cleaning',
      'Refrigerant Level Check & Top-Off',
      'Deep Coil Cleaning Service',
      'Extended Parts & Labor Warranty',
      'Annual Energy Efficiency Report',
    ],
  },
];

export default function ProtectionPlansPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="pt-28 pb-4 relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/e632399a85eed254d6185e39d54039e2.jpg"
            alt="HVAC protection plans"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-white"></div>
        </div>
        <div className="max-w-[1400px] mx-auto px-6 relative z-10">
          <div className="text-center">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-6 font-medium"
            >
              <i className="ri-arrow-left-line"></i>
              Back to Home
            </Link>
          </div>
        </div>
      </section>

      <ProtectionPlans />

      <section className="py-16 bg-gradient-to-br from-brand-navy to-brand-navy-dark">
        <div className="max-w-[1400px] mx-auto px-6 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Questions About Our Plans?
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Our team can help you choose the right protection plan for your home and budget.
          </p>
          <a
            href="tel:+18005551234"
            className="inline-flex items-center gap-3 bg-brand-red text-white px-10 py-5 rounded-full text-lg font-bold hover:bg-brand-red-dark transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line"></i>
            Call Us: (800) 555-1234
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
